import {apiClient,type ApiRequestConfig} from './api';
export interface FixedSet {a:number;b:number;format?:string;tiebreakA?:number|null;tiebreakB?:number|null}
export interface FixedPlayer {displayName?:string;name?:string;profileName?:string}
export interface FixedCourt {courtEntryId?:string|null;sets?:FixedSet[];teamA?:FixedPlayer[];teamB?:FixedPlayer[];solo?:FixedPlayer;pair?:FixedPlayer[]}
export interface FixedScoreLog {id:number;sessionId:number;updatedAt?:string;createdAt:string;practice?:boolean;courts:FixedCourt[]}
export interface FixedDraftSet {gamesA:string;gamesB:string;format:string;tiebreakA:string;tiebreakB:string}
export interface FixedDraft {mode:'FIXED_CORRECTION';scoreLogId:number;expectedUpdatedAt:string;activeMatch:number;activeSets:number[];
  courts:Array<{ordinal:number;courtEntryId:string|null;sets:FixedDraftSet[]}>}
export async function getFixedCorrection(sessionId:number,actor:string,signal?:AbortSignal):Promise<FixedScoreLog|null> {
  try {
    const {data}=await apiClient.get<{canCorrect:boolean;scoreLog:FixedScoreLog|null}>(`/api/v1/web/sessions/${sessionId}/score-log/correction`,{
      signal,headers:{'X-TARK-Expected-User-Id':actor},
    });
    return data.canCorrect&&data.scoreLog?data.scoreLog:null;
  } catch(error) {
    const status=(error as {response?:{status:number}}).response?.status;
    if(status===403||status===404)return null;
    throw error;
  }
}
export async function readFixedDraft(sessionId:number,actor:string) {
  const response=await apiClient.get<{revision:number;payload:FixedDraft}>(`/api/v1/web/sessions/${sessionId}/score-draft`,{
    headers:{'X-TARK-Expected-User-Id':actor},
  });return response.status===204?null:response.data;
}
export async function saveFixedDraft(sessionId:number,actor:string,expectedRevision:number,payload:FixedDraft,assertRequestCurrent:()=>void) {
  return (await apiClient.put<{revision:number}>(`/api/v1/web/sessions/${sessionId}/score-draft`,{expectedRevision,payload},{
    assertRequestCurrent,headers:{'X-TARK-Expected-User-Id':actor},
  } as ApiRequestConfig)).data;
}
export async function confirmFixedScore(sessionId:number,actor:string,draft:FixedDraft,assertRequestCurrent:()=>void) {
  return (await apiClient.put<FixedScoreLog>(`/api/v1/web/sessions/${sessionId}/score-log/correction`,{
    expectedUpdatedAt:draft.expectedUpdatedAt,courts:draft.courts.map(c=>({ordinal:c.ordinal,courtEntryId:c.courtEntryId,
      sets:c.sets.map(s=>({a:Number(s.gamesA),b:Number(s.gamesB),format:s.format,
        ...(s.tiebreakA!==''&&s.tiebreakB!==''?{tiebreakA:Number(s.tiebreakA),tiebreakB:Number(s.tiebreakB)}:{})})),
    })),
  },{assertRequestCurrent,headers:{'X-TARK-Expected-User-Id':actor}} as ApiRequestConfig)).data;
}
